module.exports = ".lead-icon{\r\n\twidth: 30px;\r\n}"